// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1r9Dw","modalFooterButton":"ModalNotes_modalFooterButton__1-bN6"};